import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  justify-content: center;
  margin-top: 12px;

  .MuiPaginationItem-root {
    color: #4d4f5c;
    border-color: #e8e9ec;

    /* &:hover {
      background-color: #ffffff20;
    } */
  }

  .MuiPaginationItem-page.Mui-selected {
    background-color: #a0a0a0;
    color: #fff;

    &:hover {
      background-color: #a0a0a0f2;
    }
  }
`;
